export const API_BASE_ADMIN_URL = process.env.MIX_PROJECTS_HOST_API + '/';
export const BASE_ADMIN_URL = process.env.MIX_PROJECTS_HOST;
